<template>
  <div class="mb-3 d-block d-lg-none">
    <b-nav role="tablist">
      <!-- Boton de despliegue filtros movil -->
      <b-col cols="12" class="bg-morado-claro w-100">
        <div class="d-block d-lg-none"></div>
        <b-row class="mx-0">
          <b-col cols="9" lg="12" class="p-0">
            <div
              class="text-morado-claro text-lg-center py-2 w-100 mt-2 font-weight-bold"
            >
              Aplicar más filtros
            </div>
          </b-col>
          <b-col cols="3" lg="0" class="p-0 text-right">
            <b-button
              id="boton-abrir-filtros-movil"
              data-testid="boton-abrir-filtros-movil"
              size="lg"
              variant="light"
              class="bg-white text-morado-claro my-2 border-azul-medio2"
              @click="displayFiltros = !displayFiltros"
            >
              <FontAwesomeIcon icon="sliders-h"></FontAwesomeIcon>
            </b-button>
          </b-col>
        </b-row>
      </b-col>

      <!-- Inicio Filtros -->
      <b-collapse
        is-nav
        class="col-12"
        id="navbar-filtros-movil"
        :visible="displayFiltros"
      >
        <div class="pb-3 bg-white w-100">
          <div class="accordion mt-3 filtros" id="acordion-filtros-movil">
            <!-- Filtro enseñanza -->
            <b-card
              v-for="(valor, llave, index) in filtrosPorTipo"
              :key="'card-filtros-movil-' + llave + index"
              no-body
            >
              <b-card-header class="p-0 border-bottom-0 bg-white">
                <b-button
                  :id="'header-filtros-' + llave"
                  :data-testid="'header-filtros-' + llave"
                  variant="link"
                  v-b-toggle="'collapse-filtros-' + llave"
                  class="w-100 text-left pb-0"
                >
                  <span class="cx"
                    ><FontAwesomeIcon
                      v-if="valor.showIcon"
                      :icon="valor.imagen"
                      class="mr-5 mr-1"
                    ></FontAwesomeIcon>
                    <!--TODO: No se visualiza de manera correcta el icono junto con el texto, debe ser css-->
                    <span
                      v-else
                      class="mr-2 font-weight-bold text-morado-claro"
                      >{{ valor.imagen }}</span
                    >
                    {{ traducirCategorias(llave) }}</span
                  >

                  <FontAwesomeIcon
                    icon="angle-down"
                    class="flechas float-right h5 mr-1"
                  ></FontAwesomeIcon>
                </b-button>
              </b-card-header>
              <b-collapse
                :id="'collapse-filtros-' + llave"
                accordion="filtros-movil"
                role="tabpanel"
              >
                <b-card-body>
                  <b-form-checkbox-group
                    class="py-2 px-3 border-top border-light text-morado-claro"
                    :id="'movil-filtros-' + llave"
                    :name="'movil-filtros-' + llave"
                    v-model="form[valor.valor]"
                    v-if="valor.checkbox"
                  >
                    <b-row
                      v-for="filtro in valor.filtros"
                      :key="'movil-filtro-' + llave + '-' + filtro"
                      class="ml-1"
                    >
                      <b-form-checkbox
                        class="abc-checkbox abc-checkbox-gris form-check-inline text-center py-1"
                        :id="'movil-filtro-' + llave + '-' + filtro"
                        :name="'movil-filtro-' + llave + '-' + filtro"
                        :data-testid="'movil-filtro-' + llave + '-' + filtro"
                        :value="filtro"
                      >
                        {{ traducirFiltros(filtro) }}
                      </b-form-checkbox>
                    </b-row>
                  </b-form-checkbox-group>
                  <b-form-checkbox-group
                    :id="'movil-filtros-' + llave"
                    :name="'movil-filtros-' + llave"
                    v-else
                  >
                    <b-row
                      v-for="filtro in valor.filtros"
                      :key="'movil-filtro-' + llave + '-' + filtro"
                      class="ml-1"
                    >
                      <b-form-radio
                        v-model="form[valor.valor]"
                        :key="'movil-filtro-' + llave + '-' + filtro"
                        :id="'movil-filtro-' + llave + '-' + filtro"
                        :name="'movil-filtro-' + llave + '-' + filtro"
                        :data-testid="'movil-filtro-' + llave + '-' + filtro"
                        :value="filtro"
                      >
                        {{ traducirFiltros(filtro) }}
                      </b-form-radio>
                    </b-row>
                  </b-form-checkbox-group>
                  <b-dropdown-divider />
                  <div class="px-0">
                    <b-button
                      variant="outline"
                      v-b-toggle="'collapse-filtros-' + llave"
                      class="btn-yellow mt-2 mb-1 w-100"
                      :id="'movil-aplicar-filtros-' + llave"
                      :data-testid="'movil-aplicar-filtros-' + llave"
                      @click="aplicarFiltros(form[valor.valor], llave)"
                    >
                      Filtrar
                    </b-button>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </b-collapse>
    </b-nav>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSlidersH,
  faAngleDown,
  faChalkboardTeacher,
  faClock,
  faRestroom,
  faFilter
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import MixinFiltros from "@/mixins/filtros";
library.add(
  faSlidersH,
  faAngleDown,
  faChalkboardTeacher,
  faClock,
  faRestroom,
  faFilter
);
export default {
  //props
  //components
  components: {
    FontAwesomeIcon
  },
  mixins: [MixinFiltros],
  //data
  data() {
    return {
      displayFiltros: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/busqueda/filtros/FiltrosMovil.vue